<template>
    <div class="newsCenter">
        <ul class="lists">
            <li v-for="(n,i) in navLists" :key="i" v-bind:class='{ lists_active: news_index == i} '
                @click="getNewsInfo(i)">{{$t(n)}}
            </li>
        </ul>
        <newsList v-for="(n,o) in newsLists" :newsContent="n" :key="o"></newsList>
        <div v-html="pagination" class="paging_numbers" ref="pagination">
        </div>
    </div>
</template>

<script>
import newsList from "../../components/endPage/newsList";
export default {
  name: "newsCenter",
  components: {
    newsList
  },
  inject: ["showMsg"],
  data: function() {
    return {
      navLists: ["newsNav[0]", "newsNav[1]"],
      news_index: 0,
      pagination: "",
      newsLists: ""
    };
  },
  created: function() {
    this.getNewsInfo(0);
    this.$store.commit("set_current", "-1");
    this.$store.commit("set_title", "footerNav[1]");
  },
  methods: {
    getNewsInfo(i) {
      this.news_index = i;
      let n = parseInt(i) + parseInt("1");
      this.$http({
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        method: "post",
        url: this.weburl + "/home/Other/getNewsList",
        dataType: "json",
        data: {
          tag_id: n,
          lang: window.$lang
        }
      })
        .then(res => {
          if (res.data.status === 1) {
            this.pagination = res.data.result.show;
            this.newsLists = res.data.result.param;
            this.getPage(n, 1);
            if (this.pagination) {
              setTimeout(() => {
                this.GetDom();
              }, 1000);
            }
          }
        })
        .catch(() => {
          this.showMsg(this.$t("error_msg"));
        });
    },
    getPage(n, p) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.$http({
        method: "post",
        url: this.weburl + "/home/Other/getNewsList?p=" + p,
        dataType: "json",
        data: {
          tag_id: n,
          lang: window.$lang
        }
      })
        .then(res => {
          if (res.data.status === 1) {
            this.newsLists = res.data.result.param;
            this.pagination = res.data.result.show;
            setTimeout(() => {
              this.GetDom();
            }, 1000);
          }
        })
        .catch(() => {
          this.showMsg(this.$t("error_msg"));
        });
    },
    GetDom() {
      let n = parseInt(this.news_index) + parseInt("1");
      var DOM = this.$refs.pagination;
      var a_dom = DOM.getElementsByTagName("a");
      var that = this;
      for (var i = 0; i < a_dom.length; i++) {
        a_dom[i].onclick = function() {
          that.getPage(n, this.dataset.p);
        };
      }
    }
  },
  mounted() {
    setTimeout(() => {
      this.GetDom();
    }, 1000);
  },
  computed: {
    //计算属性，
    end_information: function() {
      return this.$store.state.endPage.end_information;
    },
    weburl: function() {
      return this.$store.state.weburl;
    }
  }
};
</script>

<style scoped lang="less">
@import "../../assets/less/nav";
.newsCenter {
  background: @bg;
  padding-bottom: 1px;
}
.lists {
  margin-bottom: 20px;
}
.lists_active {
  color: @brick_red;
  &:after {
    background: @brick_red;
  }
}
</style>
<style>
@import "../../assets/css/pagination.css";
</style>
